import { Link } from "react-router-dom";
import "./Legal.css";

function Privacidad() {
  return (
    <div className="legal-pagina">
      <Link to="/" className="legal-volver">← Volver al inicio</Link>
      <h1 className="legal-titulo">Política de Privacidad</h1>
      <p className="legal-actualizado">Última actualización: septiembre de 2026</p>

      <p>
        En Glowroom MVD respetamos tu privacidad. Esta página explica qué datos
        recolectamos cuando creás una cuenta o reservás un turno en nuestro sitio,
        para qué los usamos y cómo los cuidamos.
      </p>

      <h2>Qué datos recolectamos</h2>
      <ul>
        <li>Nombre, email y teléfono que ingresás al crear tu cuenta.</li>
        <li>Instagram (opcional), si decidís compartirlo.</li>
        <li>
          Si te registrás o iniciás sesión con Google, recibimos tu nombre, email
          y foto de perfil que Google nos comparte con tu autorización. Nunca
          accedemos a tu contraseña de Google ni a otra información de tu cuenta.
        </li>
        <li>Los turnos que reservás, los servicios elegidos y notas asociadas a tu perfil (por ejemplo, preferencias o alergias que nos contás).</li>
      </ul>

      <h2>Para qué usamos tus datos</h2>
      <ul>
        <li>Crear y administrar tu cuenta.</li>
        <li>Gestionar tus turnos y contactarte por email o WhatsApp sobre tu reserva.</li>
        <li>Mejorar la atención que te damos en el estudio.</li>
      </ul>

      <h2>Con quién compartimos tus datos</h2>
      <p>
        No vendemos ni compartimos tus datos con terceros para fines publicitarios.
        Tus datos solo son accesibles por el equipo de Glowroom MVD y por los
        proveedores técnicos que usamos para operar el sitio (hosting y base de
        datos), quienes no pueden usarlos para otro fin.
      </p>

      <h2>Tus derechos</h2>
      <p>
        Podés pedirnos en cualquier momento que te mostremos, corrijamos o
        eliminemos tus datos, escribiéndonos a{" "}
        <a href="mailto:glowroombycata@gmail.com">glowroombycata@gmail.com</a> o
        por WhatsApp al 099 481 951.
      </p>

      <h2>Contacto</h2>
      <p>
        Si tenés dudas sobre esta política, escribinos a{" "}
        <a href="mailto:glowroombycata@gmail.com">glowroombycata@gmail.com</a>.
      </p>
    </div>
  );
}

export default Privacidad;
